import { styled } from "@mui/material/styles";
import { AddAPhotoOutlined, Delete } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";
import { isNil } from "lodash";
import { LoadingButton } from "@mui/lab";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const FileUpload = ({ onChange, file, disabled, loading }) => {
  const handleChange = (e) => {
    onChange(e.target.files[0]);
  };

  return (
    <Box>
      {isNil(file) && (
        <LoadingButton
          component="label"
          variant="outlined"
          startIcon={<AddAPhotoOutlined />}
          size="large"
          fullWidth
          sx={{
            mb: 1,
          }}
          disabled={disabled}
          loading={loading}
        >
          Upload
          <VisuallyHiddenInput type="file" onChange={handleChange} />
        </LoadingButton>
      )}

      {!isNil(file) && (
        <Box className="items-center">
          <Box>{file.name}</Box>
          <IconButton color="primary" onClick={() => onChange(null)}>
            <Delete fontSize="small" />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default FileUpload;
